import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import Home from "./Components/pages/Home";
import Details from "./Components/pages/deatis";
import ProfilePage from "./Components/pages/profilePage";
import MobileNav from "./Components/Global/mobileNav";
import Notification from "./Components/main/notification/Notification";
import ScrollToTop from "./context/scroll";
import SearchResultPage from "./Components/pages/searchResultPage";
import MobileSearchTabs from "./Components/pages/mobileSearchTabs";
import MobileProfile from "./Components/pages/mobileProfile";
import OtherProfilePage from "./Components/pages/otherProfile";
import WhisListPage from "./Components/pages/whisListPage";
import BookingConfirmPage from "./Components/pages/bookingConfirmPage";
import Terms from "./Components/pages/Terms";
import Privacy from "./Components/pages/Privacy";
import FaqSection from "./Components/pages/Faq";
import AboutUs from "./Components/pages/AboutUs";
import ContactUs from "./Components/pages/ContactUs";
import Error from "./Components/pages/404";
import Footer from "./Components/shared/footer/Footer";
import CreateTable from "./Components/pages/CreateTable";
import TableBanner from "./Components/pages/tableBanner";
import LoginModal from "./Components/main/loginModal/LoginModal";
import { useEffect, useState } from "react";
import InputModal from "./Components/main/InterestInput/InputModal";
import QuestionAnswer from "./Components/pages/QuestionAnswer";
import { generateDeviceId } from "./services/createDeviceId";
import axios from "axios";
import { base_url } from "./config";
import BlogSection from "./Components/pages/BlogSection";
import BlogDetail from "./Components/pages/BlogDetail";

function App() {
  const [isVisible, setIsVisible] = useState(false);
  const [topPosition, setTopPosition] = useState(10);

 
  const getDeviceType = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    if (/mobile|android|iphone|ipad|tablet/i.test(userAgent)) {
      return "mobile";
    }
    return "web"; // Default to web if not mobile/tablet
  };

  const refresh_token = localStorage.getItem("@userRefreshToken");
  const accessToken = localStorage.getItem("@user");
  async function getAccessToken() {
    let apiResponse = null;
    try {
      const response = await axios.post(
        `${base_url}/oauth/token`,
        {
          refresh_token: refresh_token,
          client_id: "CLIENT002",
          client_secret: "5PY02KdOpCX5FO93jSjPa7gKsBvQF",
          grant_type: "refresh_token",
          device_id: localStorage.getItem("deviceId"),
          device_type: getDeviceType(),
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("======>", response.status);
      apiResponse = response.data;
      // console.log("Refresh Access Token Response:", response.data);
      localStorage.setItem("@user", response.data.access_token);
      localStorage.setItem("@userRefreshToken", response.data.refresh_token);
      if (response.status === 401) {
        localStorage.removeItem("@user");
        localStorage.removeItem("@userRefreshToken");
      }
      return response.data;
    } catch (error) {
      console.error("Error fetching access token:", error);
      if (apiResponse === 401) {
        localStorage.removeItem("@user");
        localStorage.removeItem("@userRefreshToken");
      }
      throw error;
    }
  }

  function scheduleTokenRefresh() {
    const expiry = localStorage.getItem("@tokenExpiry");
    console.log("=========> scheduleTokenRefresh", expiry);
    if (expiry) {
      const timeLeft = expiry - Date.now();
      if (timeLeft > 0) {
        setTimeout(getAccessToken, timeLeft);
      } else {
        getAccessToken(); // Expired, refresh immediately
      }
    }
  }

  function initializeTokenRefresh() {
    if (refresh_token && accessToken) {
      scheduleTokenRefresh();
    }
    // getAccessToken();
  }

  useEffect(() => {
    if (accessToken) {
      // Initialize token refresh on app load
      initializeTokenRefresh();
    }
  }, []);
  const slideGoDown = () => {
    const totalTime = 1500; // Total animation time
    const steps = 800; // Number of steps
    const intervalTime = totalTime / steps; // Time per step
    const increment = 1300 / steps; // Position change per step

    let interval = setInterval(() => {
      setTopPosition((prev) => {
        if (prev >= 80) {
          clearInterval(interval); // Stop the interval
          setTimeout(() => setIsVisible(false), 0); // Change state after animation ends
          return 80; // Ensure it stops at the original position
        }
        return prev + increment; // Increment position to slide down
      });
    }, intervalTime);
  };

  const BlankModal = ({ isVisible, setIsVisible }) => {
    return (
      <div
        className={`fixed inset-0 z-[1000]  transition-opacity duration-300 ${
          isVisible ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
      >
        <div
          className="absolute inset-0 login-slide-up  bg-black"
          onClick={() => setIsVisible(false)}
        ></div>
        <div className="relative w-full h-screen">
          <div
            style={{ top: `${topPosition}%` }} // Dynamic top position
            className="absolute w-full h-screen transition-none"
          >
            <InputModal setIsVisible={setIsVisible} slideGoDOwn={slideGoDown} />
          </div>
        </div>
      </div>
    );
  };

  const getDeviceId = async () => {
    const deviceId = await generateDeviceId();
    console.log("========> Generated DeviceId", deviceId);
    localStorage.setItem("deviceId", deviceId);
  };

  useEffect(() => {
    if (
      localStorage.getItem("deviceId") === null ||
      localStorage.getItem("deviceId") === undefined ||
      localStorage.getItem("deviceId") === "" ||
      !localStorage.getItem("deviceId")
    ) {
      getDeviceId();
    }
  }, []);

   const [userType, setUserType] = useState(null);

   useEffect(() => {
    const storedType = localStorage.getItem("userType");

    setUserType(storedType);
  }, []);



  return (
    <BrowserRouter>
      <BlankModal setIsVisible={setIsVisible} isVisible={isVisible} />
      <ScrollToTop />
        <Routes>
          <Route path="/" element={
            <section data-w-id="5f9cc665505a9a8ec46d478c" className="body">
      {userType === "NO_HOST"  ? <QuestionAnswer /> : <Home />}
    </section>
          } />
          <Route path="/login" element={
            <section data-w-id="5f9cc665505a9a8ec46d478c" className="body">
              <Home />
            </section>
          } />
          <Route path="/create-table" element={
            <section data-w-id="5f9cc665505a9a8ec46d478c" className="body">
              <CreateTable />
            </section>
          } />
          <Route path="/table-banner/:id" element={
            <section data-w-id="5f9cc665505a9a8ec46d478c" className="body">
              <TableBanner />
            </section>
          } />
          <Route path="/details" element={
            <section data-w-id="5f9cc665505a9a8ec46d478c" className="body">
              <Details />
            </section>
          } />
          <Route
            path="/booking/confirmation"
            element={
              <section data-w-id="5f9cc665505a9a8ec46d478c" className="body">
                <Details open={true} />
              </section>
            }
          />
          <Route path="/profile/myprofile" element={
            <section data-w-id="5f9cc665505a9a8ec46d478c" className="body">
              <ProfilePage />
            </section>
          } />
          <Route path="/viewprofile" element={
            <section data-w-id="5f9cc665505a9a8ec46d478c" className="body">
              <OtherProfilePage />
            </section>
          } />
          <Route path="/notification" element={
            <section data-w-id="5f9cc665505a9a8ec46d478c" className="body">
              <Notification />
            </section>
          } />
          <Route path="/wishlist" element={
            <section data-w-id="5f9cc665505a9a8ec46d478c" className="body">
              <WhisListPage />
            </section>
          } />
          <Route path="/mobileSearch" element={
            <section data-w-id="5f9cc665505a9a8ec46d478c" className="body">
              <MobileSearchTabs />
            </section>
          } />
          <Route path="/searchresult" element={
            <section data-w-id="5f9cc665505a9a8ec46d478c" className="body">
              <SearchResultPage />
            </section>
          } />
          <Route path="/mobileProfile" element={
            <section data-w-id="5f9cc665505a9a8ec46d478c" className="body">
              <MobileProfile />
            </section>
          } />
          <Route path="/booking/success" element={
            <section data-w-id="5f9cc665505a9a8ec46d478c" className="body">
              <BookingConfirmPage />
            </section>
          } />
          <Route path="/terms" element={
            <section data-w-id="5f9cc665505a9a8ec46d478c" className="body">
              <Terms />
            </section>
          } />
          <Route path="/privacy" element={
            <section data-w-id="5f9cc665505a9a8ec46d478c" className="body">
              <Privacy />
            </section>
          } />
          <Route path="/faq" element={
            <section data-w-id="5f9cc665505a9a8ec46d478c" className="body">
              <FaqSection />
            </section>
          } />
          <Route path="/blogs" element={
            <section data-w-id="5f9cc665505a9a8ec46d478c" className="body">
              <BlogSection />
            </section>
          } />
          <Route path="/blogs/:id" element={
            <section data-w-id="5f9cc665505a9a8ec46d478c" className="body">
              <BlogDetail />
            </section>
          } />
          <Route path="/about-us" element={
            <section data-w-id="5f9cc665505a9a8ec46d478c" className="body">
              <AboutUs />
            </section>
          } />
          <Route path="/404" element={
            <section data-w-id="5f9cc665505a9a8ec46d478c" className="body">
              <Error />
            </section>
          } />
          <Route path="/contact-us" element={
            <section data-w-id="5f9cc665505a9a8ec46d478c" className="body">
              <ContactUs />
            </section>
          } />
          <Route
            path="/tables-curated-just-for-you"
            element={
              <section data-w-id="5f9cc665505a9a8ec46d478c" className="body">

             {userType === "NO_HOST"  ||  !localStorage.getItem("@userAccount")? <QuestionAnswer /> : <Home />}

                {/* <QuestionAnswer /> */}
              </section>
            }
          />
          <Route
            path="*"
            element={
              <section data-w-id="5f9cc665505a9a8ec46d478c" className="body">
                <Error />
                <Footer />
              </section>
            }
          />
        </Routes>
        <MobileNav setMobileSearchBar={false} />
      <ScrollToTop />
    </BrowserRouter>
  );
}

export default App;
